import { urlDaLoja } from "config/appAndroid";

/**
 * O selo oficial "Disponível no Google Play", com o link para o app na loja.
 *
 * O PNG (public/images/badges/google-play-pt-br.png) é o da página de selos do Google, sem edição:
 * as diretrizes de marca proíbem recolorir, recortar ou redesenhar o selo, e ele já traz embutida a
 * área de respiro exigida em volta — por isso nenhuma margem extra aqui. A linha legal ("Google Play e
 * o logotipo do Google Play são marcas da Google LLC.") fica no rodapé, que aparece em todas as telas
 * onde o selo aparece.
 *
 * Quem decide SE o selo aparece (app publicado, fora do app) é quem usa; este componente só desenha.
 * `className` dá a altura; a largura acompanha pela proporção do arquivo.
 *
 * `novaAba` é para o computador. No Android o link é entregue ao app da Play Store, e uma aba nova
 * ficaria para trás com a versão web da loja quando a pessoa voltasse ao navegador.
 */
export default function SeloGooglePlay({ origem, className = "h-12", novaAba = false, onClick }) {
	return (
		<a
			href={urlDaLoja(origem)}
			target={novaAba ? "_blank" : undefined}
			rel="noopener noreferrer"
			onClick={onClick}
			className="inline-block shrink-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
		>
			<img
				src="/images/badges/google-play-pt-br.png"
				width="646"
				height="250"
				alt="Disponível no Google Play"
				className={`w-auto ${className}`}
			/>
		</a>
	);
}
